import React, { Ref } from 'react'
import { TextField } from '@alto-avios/alto-ui'
import MobileModal from '../../MobileModal/MobileModal'
import {
  AutoCompleteProps,
  AutoCompleteItemAttributes,
  AUTOCOMPLETE_FIELD_ICON_PROPS,
} from './AutoComplete.types'
import { useLiftMediaQuery } from '../../../hooks/useLiftMediaQuery'
import { deviceSizes } from '../../../theme/deviceSizes'
import AutoComplete from './AutoComplete'

export const AutoCompleteWithMobileModal = React.forwardRef(
  <TItem extends AutoCompleteItemAttributes>(
    props: AutoCompleteProps<AutoCompleteItemAttributes>,
    forwardedRef: React.ForwardedRef<HTMLInputElement>
  ) => {
    const {
      name,
      label,
      value,
      error,
      disabled,
      items,
      gridArea,
      onSelectedItemChange,
      isRequired = true,
    } = props
    const [isOpen, setIsOpen] = React.useState(false)
    const isLargerThanMobile = useLiftMediaQuery(`(min-width: ${deviceSizes.medium})`)
    const childRef: Ref<HTMLButtonElement | HTMLInputElement> = React.createRef()

    const handlePlaceholderFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsOpen(true)
      e.currentTarget.blur()
    }

    return (
      <MobileModal
        isModalVisible={isOpen}
        handleModalClose={() => {
          setIsOpen(false)
        }}
        id="field-destination-mobile-modal"
        placeholder={
          <>
            <TextField
              isReadOnly
              onFocus={handlePlaceholderFocus}
              name={name}
              label={label}
              iconEndProps={AUTOCOMPLETE_FIELD_ICON_PROPS}
              aria-disabled={disabled}
              errorMessage={error}
              isInvalid={!!error}
              isDisabled={disabled}
              value={value}
              isRequired={isRequired}
            />
            {!isLargerThanMobile ? props.helperMessage : null}
          </>
        }
      >
        <AutoComplete
          {...props}
          isRequired={isRequired}
          items={items}
          ref={(forwardedRef ?? childRef) as Ref<HTMLInputElement>}
          onIsOpenChange={(state) => {
            setIsOpen(state.isOpen || false)
          }}
          onSelectedItemChange={(changes) => {
            if (onSelectedItemChange) {
              onSelectedItemChange(changes)
              setIsOpen(false)
            }
          }}
          helperMessage={isLargerThanMobile ? props.helperMessage : undefined}
        />
      </MobileModal>
    )
  }
)
